/*
 * @Author: your name
 * @Date: 2022-03-04 15:53:16
 * @LastEditTime: 2022-04-28 11:33:08
 * @LastEditors: 么东欣
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /bijixia-wx-h5/src/components/index.js
 */
//组件统一出口
import shareNav from './order-popup/share-nav.vue';
import inputNumber from './input-number/index.vue';
import iosSelect from './ios-select/index.vue';
import openAppBar from './open-app-bar'
import OpenAppWx from './open-app-bar/open-app-wx.vue'

const views = {
	shareNav,
	inputNumber,
	iosSelect,
	openAppBar,
	OpenAppWx,
}

const install = function (Vue) {
	Object.keys(views).forEach((key) => {
		Vue.component(key, views[key])
	})
}

const API = {
	install
}
export default API;

// 按需引用的组件
import button from './button'
import radio from './radio'
import tag from './tag'
import circlePercent from './circle-percent'
import card from './card'
import pageLoading from './page-loading'
import groupButton from './button/button-group.vue'
import input from './input';
import rate from './rate/index.vue'
import progress from './progress/index.vue'
import zan from './zan/index.vue'
import tab from './tabs'
import tabPane from './tabs/tab-pane.vue'
import avatar from './avatar'
import slider from './slider'
import nodata from './no-data'
import areaSelect from './ios-select/area'
import dateTimeSelect from './ios-select/dateTime'
import checkbox from './checkbox'

export const GxxtRadio = radio
export const GxxtButton = button
export const GxxtTag = tag
export const GxxtCirclePercent = circlePercent
export const GxxtCard = card
export const GxxtPageLoading = pageLoading
export const GxxtGroupButton = groupButton
export const GxxtInput = input
export const GxxtRate = rate
export const GxxtProgress = progress
export const GxxtZan = zan
export const GxxtTab = tab
export const GxxtTabPane = tabPane
export const GxxtIosSelect = iosSelect
export const GxxtInputNumber = inputNumber
export const GxxtAvatar = avatar
export const GxxtSlider = slider
export const GxxtNoData = nodata
export const GxxtAreaSelect = areaSelect
export const GxxtDateTimeSelect = dateTimeSelect
export const GxxtCheckbox = checkbox


import { $messageBox } from './messageBox/index.js'
import { $toaster } from './toaster/index.js'

export const initCustomPlugin = (app) => {
	app.use($messageBox)
	app.use($toaster)
}